import type {
  ScreenMembersOnSignupId,
  SignupOptions,
  TransactionMembersOnSignupId,
} from '@auth0/auth0-acul-react/types';
import {
  useScreen,
  useSignupId,
  useTransaction,
} from '@auth0/auth0-acul-react/signup-id';

import { executeSafely } from '@/utils/helpers/executeSafely';

export const useSignupIdManager = () => {
  const signupId = useSignupId();

  const screen: ScreenMembersOnSignupId = useScreen();
  const transaction: TransactionMembersOnSignupId = useTransaction();
  const { alternateConnections } = transaction;

  const { isCaptchaAvailable, texts, loginLink, captcha } = screen;

  const handleSignup = async (payload: SignupOptions): Promise<void> => {
    // Clean and prepare data like login-id pattern
    const options: SignupOptions = {};

    if (payload.email?.trim()) {
      options.email = payload.email.trim();
    }
    if (payload.username?.trim()) {
      options.username = payload.username.trim();
    }
    if (screen.isCaptchaAvailable && payload.captcha?.trim()) {
      options.captcha = payload.captcha.trim();
    }

    await executeSafely(`Signup with options: ${JSON.stringify(options)}`, () =>
      signupId.signup(options),
    );
  };

  return {
    transaction,
    signupId,
    handleSignup,
    texts,
    isCaptchaAvailable,
    loginLink,
    alternateConnections,
    captcha,
  };
};
